import { Component, OnInit, ViewChild } from '@angular/core';
import { CommonService } from '../services/common.service';

@Component({
    selector: 'app-mon-compte',
    templateUrl: './mon-compte.component.html',
    styleUrls: ['./mon-compte.component.css'],
    standalone: false
})
export class MonCompteComponent implements OnInit {
  user: any = {
    oldPassword: { value: '', showPassword: false },
    pwd: { value: '', showPassword: false },
    mdpconfirm: { value: '', showPassword: false }
  };
  error = '';
  errorForm = '';
  errorPwd: boolean = false;
  changerCouleurNom = false;
  couleurBordureDefaut = '#ccc';
  couleurErreur = 'red';
  isSSO: boolean = false;
  societe: any = {};
  oldPasswordCrypte: String = '';
  constructor(public common: CommonService) { }

  ngOnInit() {
    this.societe = this.common.local.getObject('paramSociete') || {};
    this.isSSO = !!this.societe.SSO;
    this.getInfoUser();
  }

  saveInfo() {
    if (this.validateChamps()) {
      this.save();
    }
  }

  getInfoUser() {
    const param = {
      'servlet': 'DBGestionUser',
      'module': 'Recylog',
      'type': 'map',
      'compression': 'false',
      'data': {
        'OPERATION': {
          'typeParam': 'int',
          'valeur': 1
        },
        'CLEF_USER': {
          'typeParam': 'int',
          'valeur': this.common.user[0]
        }
      }
    };
    this.common.post('', { param: param }).then((datas: any) => {
      this.user = datas.data;
      this.oldPasswordCrypte = this.user.oldPassword;
      this.user.oldPassword = { value: '', showPassword: false };
      this.user.pwd = { value: '', showPassword: false };
      this.user.mdpconfirm = { value: '', showPassword: false };
    }).catch(err => {
    });

  }

  save() {
    this.errorForm = '';
    this.errorPwd = false;
    const userObject = {
      'nom': this.user.nom,
      'id': this.common.user[0],
      'prenom': this.user.prenom,
      'mail': this.user.mail,
      'nomclass': 'User',
      'pwd': this.user.pwd.value,
      'oldPassword': this.user.oldPassword.value
    };
    if(this.isSSO) {
      delete userObject.pwd;
      delete userObject.oldPassword;
    }
    const param = {
      'servlet': 'DBGestionUser',
      'module': 'Recylog',
      'type': 'map',
      'compression': 'false',
      'data': {
        'OPERATION': {
          'typeParam': 'int',
          'valeur': 2
        },
        'USER': userObject
      }
    };
    this.common.post('', { param: param }).then((res: any) => {
      if (res.data && res.data.message) {
        this.errorForm = res.data.message;
      } else {
        if(!this.isSSO && this.user.pwd.value) {
          userObject['oldPassword'] = this.oldPasswordCrypte;
          userObject['login'] = this.user.login;
          this.common.updatePwdEcostat(this.common.user[0], userObject).then(dt => {
            this.common.closeModal();
          });
        }else
          this.common.closeModal();
      }
    }).catch(err => {
    });
  }

  

  validateChamps() {
    this.errorForm = '';
    this.errorPwd = false;

      if (!this.user.nom || !this.user.prenom || !this.user.mail) {
        this.errorForm = 'Les champs Nom, Prénom et  Mail sont obligatoires.';
        return false;
      }

      if(!this.common.validatePatternMail(this.user.mail)) {
        this.errorForm = 'La valeur du champs mail est invalide.';
        return false;
      }
      if(!this.isSSO) {
        if ((!this.user.pwd?.value && this.user.oldPassword?.value) || (!this.user.oldPassword?.value && this.user.pwd?.value) ) {
          this.errorForm = 'Les champs mots de passe sont obligatoires.';
          return false;
        }
  
        if (this.user.pwd.value !== this.user.mdpconfirm.value) {
          this.errorForm = 'Le nouveau mot de passe et sa confirmation ne correspondent pas.';
          return false;
        }
        if (this.user.pwd.value && !this.checkPasswordValidity(this.user.pwd.value)) {
          this.errorForm = '';
          return false;
        }
      }
    return true;
  }

  togglePasswordVisibility(type) {
    if (type === 'pwd') {
      this.user.pwd.showPassword = !this.user.pwd.showPassword;
    } else if (type === 'oldPassword') {
      this.user.oldPassword.showPassword = !this.user.oldPassword.showPassword;
    } else if (type === 'mdpconfirm') {
      this.user.mdpconfirm.showPassword = !this.user.mdpconfirm.showPassword;
    }
  }

  getPasswordType(type) {
    if (type === 'pwd') {
      return this.user.pwd.showPassword ? 'text' : 'password';
    } else if (type === 'oldPassword') {
      return this.user.oldPassword.showPassword ? 'text' : 'password';
    } else {
      return this.user.mdpconfirm.showPassword ? 'text' : 'password';
    }
  }

  disablePaste(event: ClipboardEvent): void {
    event.preventDefault();
  }

  checkPasswordValidity(password: string): boolean {
    this.errorForm = '';
    // Vérifier la longueur minimale de 12 caractères
    if (password.length < 12) {
      this.errorPwd = true;
      console.log('La longueur minimale doit être de 12 caractères');
      return false;
    }

    // Vérifier la présence d'au moins une majuscule
    if (!/[A-Z]/.test(password)) {
      this.errorPwd = true;
      console.log('Il doit contenir au moins une majuscule');
      return false;
    }

    // Vérifier la présence d'au moins une minuscule
    if (!/[a-z]/.test(password)) {
      this.errorPwd = true;
      console.log('Il doit contenir au moins une minuscule');
      return false;
    }

    // Vérifier la présence d'au moins un chiffre
    if (!/\d/.test(password)) {
      this.errorPwd = true;
      console.log('Il doit contenir au moins un chiffre');
      return false;
    }

    // Vérifier la présence d'au moins un caractère spécial
    if (!/[!@#$%^&*()\-=_+[\]{};':"\\|,.<>/?]+/.test(password)) {
      this.errorPwd = true;
      console.log('Il doit contenir au moins un caractère spécial');
      return false;
    }

    // Toutes les règles sont respectées
    return true;
  }
}
